import React, { useState } from "react";
import axios from "axios";
import { Routes, Route, useNavigate } from "react-router-dom";
//MUI components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Footer from "../footer/footer";

function Login(e) {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [authenticated, setAuthenticated] = useState(false);
  const [comment, setComment] = useState("");

  const navigate = useNavigate();

  {
    /*Sending credentials for validating*/
  }
  function login(e) {
    e.preventDefault();
    axios
      .post(
        "https://dataxact-backend.vercel.app/admin/loginAdmin",
        {
          email: email,
          password: pass,
        },
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      )
      .then((response) => {
        const ans = response.data;
        if (ans === "Login success") {
          setAuthenticated(true);
          setComment("");
          localStorage.setItem("isAuthenticated", true);

          window.location.href = "/admin/dashboard";
        } else if (ans === "Invalid Password") {
          setAuthenticated(false);
          setComment("Invalid Password");
        } else if (ans === "No admin exist with given email:") {
          setAuthenticated(false);
          setComment("No Such Admin Exist ");
        }
        //response.data
      });
  }

  return (
    <>
      <Container>
        <Box
          component="img"
          src="dsc-logo.png"
          sx={{
            height: {
              xl: "6rem",
              lg: "5.5rem",
              md: "5rem",
              sm: "4.5rem",
              xs: "3rem",
            },
            marginTop: "2rem",
            display: "flex",
            marginLeft: "auto",
            marginRight: "auto",
            textAlign: "center",
            alignItems: "center",
          }}
        />
        <Grid
          sx={{ position: "relative", top: "3rem" }}
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          display="flex"
        >
          <Grid item>
            <Typography></Typography>
          </Grid>
          {/*main content box here*/}
          <Grid item>
            <Box
              sx={{
                height: { lg: "20rem", md: "20rem", sm: "20rem", xs: "20rem" },
                width: {
                  lg: "25rem",
                  md: "25rem",
                  sm: "25rem",
                  xs: "20rem",
                  borderRadius: "1rem",
                },
                backgroundColor: "#ffffff",
              }}
            >
              {/*content here*/}
              <Typography
                variant="h2"
                sx={{
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: "2rem",
                  margin: "1rem",
                  position: "relative",
                  top: "1rem",
                }}
              >
                Login
              </Typography>
              <Container>
                <TextField
                  onChange={(e) => setEmail(e.target.value)}
                  id="standard-basic"
                  fullWidth
                  color="primary"
                  label="Email"
                  variant="standard"
                />
                <br></br>
                <TextField
                  onChange={(e) => setPass(e.target.value)}
                  id="standard-basic"
                  fullWidth
                  label="Password"
                  type="password"
                  variant="standard"
                  sx={{
                    marginTop: "1rem",
                    textAlign: "center",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                />
                <Typography
                  variant="caption"
                  sx={{
                    color: "red",
                    marginTop: "2.5rem",
                    position: "relative",
                    top: "0.5rem",
                  }}
                >
                  {comment}
                </Typography>
                <br></br>
                <Button
                  variant="contained"
                  onClick={login}
                  sx={{
                    marginTop: "1rem",
                    backgroundColor: "#000000",
                    ":hover": { backgroundColor: "#000000", color: "primary" },
                  }}
                >
                  Login
                </Button>
              </Container>
            </Box>
          </Grid>
          <Grid item>
            <Typography></Typography>
          </Grid>
        </Grid>
      </Container>
      <Footer
        upload="false"
        sx={{ position: "fixed", bottom: 0, marginTop: "10rem" }}
      ></Footer>
    </>
  );
}
export default Login;
